module.exports = __webpack_public_path__ + "static/img/3-2.932b5736.png";